<template>
  <f7-block strong inset class="users-search-block" v-if="isAuthenticated">
    <f7-list media-list>
      <f7-list-item>
        <f7-block-header>{{ $t("avocashUsers.find") }}</f7-block-header>
        <div class="item-input-wrap">
          <input type="text" @blur="clearSearch()" @keydown="updateList()"
            :placeholder="$t('common.searchAvoashUser')" id="autocomplete-dropdown-user-search" class="item-input" />
          <span class="input-clear-button" @click="clearSearch()"></span>
        </div>
      </f7-list-item>
    </f7-list>
  </f7-block>
</template>
<style scoped>
.userImage img {
  width: 48px;
  border-radius: 24px;
}
.users-search-block {
  margin: 16px;
}
</style>
<script setup>
import { useUsersList } from '../js/composables/useUsersList.js';

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const {
  isAuthenticated,
  updateList,
  clearSearch,
} = useUsersList({ f7route: props.f7route, f7router: props.f7router });
</script>
